import { render, staticRenderFns } from "./CrmAgendaPage.vue?vue&type=template&id=06cee44f&scoped=true&"
import script from "./CrmAgendaPage.vue?vue&type=script&lang=js&"
export * from "./CrmAgendaPage.vue?vue&type=script&lang=js&"
import style0 from "./CrmAgendaPage.vue?vue&type=style&index=0&id=06cee44f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cee44f",
  null
  
)

export default component.exports